<app-partner-contact [partner]="partner"></app-partner-contact>
